import React from "react";
import { Navigate } from "react-router-dom";
import { getAuthToken } from "../../lib/authStorage";
import { getCaPasswordResetSession } from "../../lib/caPasswordResetSession";
import { getPortalAuthConfig } from "../../portals/portalConfig";

interface Props {
  children: React.ReactElement;
}

export default function RequireCaAuth({ children }: Props) {
  if (!getAuthToken()) {
    return <Navigate to="/" replace />;
  }
  if (getCaPasswordResetSession()) {
    const changePath =
      getPortalAuthConfig().changePasswordPath ?? "/change-password";
    return <Navigate to={changePath} replace />;
  }
  return children;
}
